import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { User } from '../../models/user';
import { API_BASE_URL } from '../../shared/api-config';
import { Implementer } from '../../models/implementer';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
  ) {}

  getUsers(email?: string, entraOid?: string) {
    let params = new HttpParams();

    if (email) {
      params = params.set('email', email);
    }

    if (entraOid) {
      params = params.set('entraOid', entraOid);
    }

    const url = `${this.baseUrl}/users`;
    return this.http.get<User[]>(url, { params });
  }

  getCurrentUser() {
    const url = `${this.baseUrl}/users/current`;
    return this.http.get<User | null>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          return of(null);
        }
        return throwError(() => err);
      }),
    );
  }

  addCurrentUser(user: User) {
    console.debug('[UserService] addCurrentUser(...)');
    return this.http.post<void>(`${this.baseUrl}/users/current`, user);
  }

  updateCurrentUser(user: User) {
    console.debug('[UserService] updateCurrentUser(...)');
    return this.http.put<void>(`${this.baseUrl}/users/current`, user);
  }

  getImplementerForCurrentUser() {
    const url = `${this.baseUrl}/users/current/implementer`;
    return this.http.get<Implementer | null>(url);
  }

  updateUser(user: User): Observable<void> {
    const url = `${this.baseUrl}/users/${user.id}`;
    return this.http.put<void>(url, user);
  }

  addUser(user: User) {
    return this.http.post<void>(`${this.baseUrl}/users`, user);
  }

  deleteUser(userId: string) {
    const url = `${this.baseUrl}/users/${userId}`;
    return this.http.delete<void>(url);
  }
}
